import http from '../http'

export default {
    /**
     * Consulta los tags del usuario.
     * @param {int} usuario
     * @returns {Promise}
     */
    all(usuario) {
        return http.get(`usuarios/${usuario}/tareas`);
    },

    /**
     * Actualizar una tarea
     * @param {int} usuario
     * @param {string} tarea
     * @returns {Promise}
     */
    update(usuario, tarea, payload) {
        return http.put(`usuarios/${usuario}/tareas/${tarea}`, payload);
    },
}